module.exports = __webpack_public_path__ + "img/fc63c156256fa0d49206dd4850485e3.22e14ffe.jpg";